import {BaseFyneAIAppPrefs} from "../fyneai-shared/BaseFyneAIAppPrefs";

export class AppPrefs extends BaseFyneAIAppPrefs {

  static readonly PREF_SELECTED_CASE_ID = "sel_case_id";

  private static instance: AppPrefs;

  static getInstance() {
    if (!this.instance) {
      this.instance = new AppPrefs();
    }
    return this.instance;
  }

  private constructor() {
    super();
  }

  getSelectedCaseId(): string | null {
    return this.prefs.getString(AppPrefs.PREF_SELECTED_CASE_ID);
  }

  setSelectedCaseId(id: string): void {
    this.prefs.setString(AppPrefs.PREF_SELECTED_CASE_ID, id);
  }
}
